exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loader-primary {\n  background-color: rgba(0, 0, 0, 0.25);\n  margin-top: -297px;\n  height: 297px;\n  padding-top: 110px; }\n\n.btn-success {\n  color: #fff;\n  background-color: #ce4990;\n  border-color: #ce4990; }\n\n.bg-blue-grey-100 {\n  background-color: white; }\n\n.card {\n  background-color: #B8E5E8; }\n\ninput {\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/user/login/login.component.scss
// module id = 1171
// module chunks = 4